import React, { useState, useEffect } from 'react';
import firebase from './Firebase';
import City from './City';
import { GoogleAuthProvider, getAuth, signInWithPopup, signOut } from "firebase/auth";
import 'bootstrap/dist/css/bootstrap.min.css';
export const MyContext = React.createContext();

const Home = () => {
    const [data, setData] = useState({ name: '', email: '', photo: '', isLogged: false })
    const signInHandler = () => {
        const provider = new GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
        const auth = getAuth();
        provider.setCustomParameters({
            'login_hint': 'user@example.com'
        });

        signInWithPopup(auth, provider)
            .then((result) => {
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;
                const user = result.user;
                setData({ name: user.displayName, email: user.email, photo: user.photoURL, isLogged: true });
            }).catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                const email = error.customData.email;
                const credential = GoogleAuthProvider.credentialFromError(error);
            });
    }

    const signOutHandler = () => {
        const auth = getAuth();
        signOut(auth).then(() => {
            setData({ name: '', email: '', photo: '', isLogged: false })
        }).catch((error) => {
        });
    }

    return (
        <>
            <div className='home'>
                <div className="log">
                    {
                        data.isLogged === true
                            ?
                            <>
                                <div className="container">
                                    <div className="row pt-3">
                                        <div className="col-3 col-sm-2">
                                            <div><img src={data.photo} alt="" className=' rounded-3' referrerPolicy='no-referrer' /></div>
                                        </div>
                                        <div className="col-9 col-sm-8">
                                            <div className=' text-center'>
                                                <h2>Welcome <span className=' text-center text-success text-capitalize'><u><i>{data.name}</i></u></span></h2>
                                                <span>{data.email}</span>
                                            </div>

                                        </div>
                                        <div className="col-12 col-sm-2 text-center mt-2 mb-2">
                                            <button onClick={signOutHandler} className="btn btn-dark ">Sign Out</button>

                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <City data={data.email} />
                            </>
                            :
                            <>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12  mt-5 mb-5">
                                            <div>
                                                <h3>This Weather App provides <span className=' text-success'><u>Temperature</u></span>, <span className=' text-success'><u>Description</u></span>, <span className=' text-success'><u>Visibility Distance</u></span>, <span className=' text-success'><u>Relative Humidity</u></span>, <span className=' text-success'><u>Country Name</u></span> and <span className=' text-success'><u>Wind Speed</u></span> in addition you can add multiple cities' weather.</h3>

                                            </div>
                                            <div className=' d-grid mt-5 mb-5'>
                                                <button onClick={signInHandler} className="btn btn-success  p-2  rounded-5"><b>Sign In with GOOGLE</b></button>
                                                <p className='mt-5 mb-5 text-center'>Copyright  &copy; 2022 | Created by <u><i>Farman Gour</i></u></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                </div>
            </div>
        </>
    )
}

export default Home;